module.exports = __webpack_public_path__ + "img/black fire.fa99bf2d.png";